<template>
  <div
    class="help-docs-panel"
    :style="panelStyle"
    @mousedown="onDragStart"
  >
    <div class="map-tool-window-header" @mousedown="onDragStart">
      <span class="map-tool-window-header-title">Documentación de Ayuda</span>
      <div class="map-tool-window-header-actions">
        <button class="control-btn" @click.stop="minimized = !minimized">
            <svg  v-if="minimized"
            viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
            <svg v-else
              viewBox="0 0 24 24"><line x1="5" y1="12" x2="19" y2="12"/></svg>
        </button>
        <button class="control-btn" title="Cerrar" @click.stop="close">
                        <svg viewBox="0 0 24 24"><line x1="5" y1="5" x2="19" y2="19"/><line x1="19" y1="5" x2="5" y2="19"/></svg>
        </button>
      </div>
    </div>
    <div v-if="!minimized" class="help-docs-body">
      <div v-if="loading" class="help-docs-state">Cargando archivos...</div>
      <div v-else-if="error" class="help-docs-state help-docs-error">{{ error }}</div>
      <div v-else-if="docs.length === 0" class="help-docs-state">No hay documentos disponibles</div>
      <table v-else class="help-docs-table">
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Descripción</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in docs" :key="item.id">
            <td>
              <a :href="contentUrl(item)" target="_blank" rel="noopener">{{ item.filename }}</a>
            </td>
            <td>{{ item.description || '-' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { vuex } from "@/components/mixin/vuex.js";
import { restDocument } from "@/components/mixin/restDocument.js";

export default {
  name: "HelpDocuments",
  mixins: [vuex, restDocument],
  data() {
    return {
      loading: false,
      error: "",
      minimized: false,
      pos: { top: 80, left: 80 },
      drag: null,
    };
  },
  computed: {
    panelStyle() {
      return { top: this.pos.top + "px", left: this.pos.left + "px" };
    },
  },
  created() {
    this.loading = true;
    this.getVisibleDocs()
      .then((response) => {
        this.docs = response.data || [];
      })
      .catch((error) => {
        console.error(error);
        this.error = "No es posible cargar los documentos";
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    close() {
      this.selectMapTool("help", false);
    },
    onDragStart(e) {
      if (e.target.tagName === "BUTTON") return;
      if (e.target.closest(".help-docs-body")) return;
      this.drag = {
        x: e.clientX - this.pos.left,
        y: e.clientY - this.pos.top,
      };
      window.addEventListener("mousemove", this.onDragMove);
      window.addEventListener("mouseup", this.onDragEnd);
    },
    onDragMove(e) {
      if (!this.drag) return;
      this.pos = {
        left: e.clientX - this.drag.x,
        top: e.clientY - this.drag.y,
      };
    },
    onDragEnd() {
      this.drag = null;
      window.removeEventListener("mousemove", this.onDragMove);
      window.removeEventListener("mouseup", this.onDragEnd);
    },
  },
  beforeDestroy() {
    window.removeEventListener("mousemove", this.onDragMove);
    window.removeEventListener("mouseup", this.onDragEnd);
  },
};
</script>

<style scoped lang="scss">
.help-docs-panel {
  position: fixed;
  width: 420px;
  max-height: 70vh;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
  z-index: 100000001;
  display: flex;
  flex-direction: column;
  user-select: none;
}

.help-docs-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  border-bottom: 1px solid #e0e0e0;
  cursor: move;
  font-weight: 600;
  background: #f9f9f9;
  border-radius: 8px 8px 0 0;
}

.help-docs-title {
  font-size: 14px;
}

.header-actions {
  display: flex;
  gap: 4px;
}

.btn-icon {
  background: none;
  border: none;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  padding: 2px 8px;
  color: #333;
  border-radius: 4px;

  &:hover {
    background: #e5e5e5;
  }
}

.help-docs-body {
  padding: 12px;
  overflow-y: auto;
  max-height: calc(70vh - 48px);
  user-select: text;
}

.help-docs-state {
  padding: 8px 4px;
  font-size: 13px;
  color: #333;
}

.help-docs-error {
  color: #b00020;
}

.help-docs-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  table-layout: fixed;

  th,
  td {
    text-align: left;
    padding: 6px 8px;
    border-bottom: 1px solid #e0e0e0;
    overflow-wrap: break-word;
    word-break: break-word;
    white-space: normal;
    vertical-align: top;
  }

  th {
    background: #f9f9f9;
    font-weight: 600;
  }

  a {
    color: #1976d2;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
